import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { GridColDef } from '@mui/x-data-grid-pro';

/**
 * Method used for the MUI DataGrid Quickfilter in mobile display when all of the data is pushed into a single column
 */
export function getDispatchCardQuickFilterValue(
	filterValue: string,
	columns: GridColDef<DispatchLeg>[]
): (value: unknown, row: DispatchLeg) => boolean {
	return (_, row): boolean => {
		return columns.some((col) => {
			const filterFn = col.getApplyQuickFilterFn?.(filterValue, col as never, {} as never);
			return Boolean(filterFn?.(undefined, row, col, {} as never));
		});
	};
}
